/* globals
    rscpCfg,
    Control,
    Debug,
    ZeroPad,
    RoundToPrecision,
    SCORM_STATUS_PASSED,
    SCORM_STATUS_FAILED,
    SCORM_STATUS_COMPLETED,
    SCORM_STATUS_INCOMPLETE,
    SCORM_STATUS_UNKNOWN,
    SCORM_STATUS_NOT_ATTEMPTED,
    SCORM_STATUS_BROWSED
*/

/* eslint-disable new-cap */
var HUNDREDTHS_PER_SECOND = 100,
    HUNDREDTHS_PER_MINUTE = HUNDREDTHS_PER_SECOND * 60,
    HUNDREDTHS_PER_HOUR = HUNDREDTHS_PER_MINUTE * 60,
    HUNDREDTHS_PER_DAY = HUNDREDTHS_PER_HOUR * 24,
    // assumed to be an "average" month (figures a leap year every 4 years) = ((365*4) + 1) / 48 days - 30.4375 days per month
    HUNDREDTHS_PER_MONTH = HUNDREDTHS_PER_DAY * (((365 * 4) + 1) / 48),
    HUNDREDTHS_PER_YEAR = HUNDREDTHS_PER_MONTH * 12,
    REG_EX_DIGITS = /\d+/g;

//
// Parses an iso8601 date/time string and returns an object that describes the
// individual date/time fields.
// The empty strings are for backwards compatibility with the previous version
// of this function.
//
function GetParsedIso8601Time (dateStr) {
    var iso8601RegExp = /^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2})(?::(\d{2})(?::(\d{2})(?:\.(\d*))?)?)?((?:([+-])(\d{2})(?::(\d{2}))?)|Z)?)?$/,
        match = iso8601RegExp.exec(dateStr),
        dateParts = {},
        timezone;

    dateParts.year = "";
    dateParts.month = "";
    dateParts.day = "";
    dateParts.hours = "";
    dateParts.minutes = "";
    dateParts.seconds = "";
    dateParts.milliseconds = "";
    dateParts.timezoneoffsetchar = "";
    dateParts.offsethours = "";
    dateParts.offsetminutes = "";

    if (! match) {
        Debug.AssertError("ERROR - unable to recognize the date format '" + dateStr + "'.");

        return dateParts;
    }

    dateParts.year = match[1] || "";
    dateParts.month = match[2] || "";
    dateParts.day = match[3] || "";
    dateParts.hours = match[4] || "";
    dateParts.minutes = match[5] || "";
    dateParts.seconds = match[6] || "";
    dateParts.milliseconds = ((match[7] || "") + "000").substring(0, 3);

    timezone = match[8];
    if (timezone && timezone === "Z") {
        dateParts.timezoneoffsetchar = "Z";
    }
    if (timezone && timezone !== "Z") {
        dateParts.timezoneoffsetchar = match[9] || "";
        dateParts.offsethours = match[10] || "";
        dateParts.offsetminutes = match[11] || "";
    }

    return dateParts;
}

// eslint-disable-next-line no-unused-vars
function ConvertIso8601TimeToUtcAnsiSql (iso8601Time) {
    var dateParts = GetParsedIso8601Time(iso8601Time),
        date = new Date(),
        dbDateTime;

    if (typeof dateParts.timezoneoffsetchar === "undefined" || dateParts.timezoneoffsetchar === "" || dateParts.timezoneoffsetchar === null) {
        date.setFullYear(dateParts.year);

        // Months happen to be zero-based in JavaScript
        date.setMonth(dateParts.month - 1);
        date.setDate(dateParts.day);
        date.setHours(dateParts.hours);
        date.setMinutes(dateParts.minutes);
        date.setSeconds(dateParts.seconds);
        date.setMilliseconds(dateParts.milliseconds);
    }
    else {
        date.setUTCFullYear(dateParts.year);

        // Months happen to be zero-based in JavaScript
        date.setUTCMonth(dateParts.month - 1);
        date.setUTCDate(dateParts.day);
        date.setUTCHours(dateParts.hours);
        date.setUTCMinutes(dateParts.minutes);
        date.setUTCSeconds(dateParts.seconds);
        date.setUTCMilliseconds(dateParts.milliseconds);

        /* eslint-disable no-new-wrappers */
        if (dateParts.timezoneoffsetchar === "-") {
            date.setUTCHours(date.getUTCHours() + new Number(dateParts.offsethours));
            date.setUTCMinutes(date.getUTCMinutes() + new Number(dateParts.offsetminutes));
        }
        else if (dateParts.timezoneoffsetchar === "+") {
            date.setUTCHours(date.getUTCHours() - new Number(dateParts.offsethours));
            date.setUTCMinutes(date.getUTCMinutes() - new Number(dateParts.offsetminutes));
        }
        /* eslint-enable no-new-wrappers */
    }

    dbDateTime = date.getUTCFullYear()
        + "-"
        // Add 1 to month because months are zero-based in JavaScript
        + ZeroPad(date.getUTCMonth() + 1, 2)
        + "-"
        + ZeroPad(date.getUTCDate(), 2)
        + "T"
        + ZeroPad(date.getUTCHours(), 2)
        + ":"
        + ZeroPad(date.getUTCMinutes(), 2)
        + ":"
        + ZeroPad(date.getUTCSeconds(), 2);

    return dbDateTime;
}

// eslint-disable-next-line no-unused-vars
function ConvertDateToIso8601String (date) {
    var zeropad = function (num) {
            return (num < 10 ? "0" : "") + num;
        },
        str = "",
        millis;

    str += date.getUTCFullYear();
    str += "-" + zeropad(date.getUTCMonth() + 1);
    str += "-" + zeropad(date.getUTCDate());
    str += "T" + zeropad(date.getUTCHours()) + ":" + zeropad(date.getUTCMinutes());
    str += ":" + zeropad(date.getUTCSeconds()) + ".";

    millis = "00" + date.getUTCMilliseconds().toString();
    // We only keep track of 100ths of a sec, so trim
    str += millis.substr(millis.length - 3, 2);
    str += "Z";

    return str;
}

//
//  Parses an iso8601 date/time string and returns a Date Object
//  Note that Date.parse() is implementation-dependent, so we roll our own
//
// eslint-disable-next-line no-unused-vars
function GetDateFromUtcIso8601Time (iso8601Time) {
    var dateParts = GetParsedIso8601Time(iso8601Time),
        retDate = new Date();

    Debug.AssertError("Expected " + iso8601Time + " to be a UTC string", dateParts.timezoneoffsetchar !== "Z");

    retDate.setUTCFullYear(dateParts.year);
    retDate.setUTCMonth(dateParts.month - 1);
    retDate.setUTCDate(dateParts.day);
    retDate.setUTCHours(dateParts.hours);
    retDate.setUTCMinutes(dateParts.minutes);
    retDate.setUTCSeconds(dateParts.seconds);
    retDate.setUTCMilliseconds(dateParts.milliseconds);

    return retDate;
}

function IsIso8601SectionDelimiter (str) {
    if (str.search(/[PYMDTHS]/) >= 0) {
        return true;
    }

    return false;
}

function ConvertIso8601TimeSpanToHundredths (strIso8601Time) {
    var intTotalHundredths = 0,
        strNumberBuilder = "",
        strCurrentCharacter = "",
        blnInTimeSection = false,
        // 100 hundreths of a seconds
        Seconds = 0,
        // 60 seconds
        Minutes = 0,
        // 60 minutes
        Hours = 0,
        // 24 hours
        Days = 0,
        // assumed to be an "average" month (figures a leap year every 4 years) = ((365*4) + 1) / 48 days - 30.4375 days per month
        Months = 0,
        // assumed to be 12 "average" months
        Years = 0,
        i;

    if (strIso8601Time === "") {
        return 0;
    }

    strIso8601Time += "";

    // start at 1 to get past the "P"
    for (i = 1; i < strIso8601Time.length; i += 1) {
        strCurrentCharacter = strIso8601Time.charAt(i);

        if (IsIso8601SectionDelimiter(strCurrentCharacter)) {
            switch (strCurrentCharacter.toUpperCase()) {
                case "Y":
                    Years = parseInt(strNumberBuilder, 10);
                    break;

                case "M":
                    if (blnInTimeSection) {
                        Minutes = parseInt(strNumberBuilder, 10);
                    }
                    else {
                        Months = parseInt(strNumberBuilder, 10);
                    }
                    break;

                case "D":
                    Days = parseInt(strNumberBuilder, 10);
                    break;

                case "H":
                    Hours = parseInt(strNumberBuilder, 10);
                    break;

                case "S":
                    Seconds = parseFloat(strNumberBuilder);
                    break;

                case "T":
                    blnInTimeSection = true;
                    break;

                default:
                    break;
            }

            strNumberBuilder = "";
        }
        else {
            // use "" to keep the number as string concats instead of numeric additions
            strNumberBuilder += "" + strCurrentCharacter;
        }
    }

    intTotalHundredths = (Years * HUNDREDTHS_PER_YEAR)
        + (Months * HUNDREDTHS_PER_MONTH)
        + (Days * HUNDREDTHS_PER_DAY)
        + (Hours * HUNDREDTHS_PER_HOUR)
        + (Minutes * HUNDREDTHS_PER_MINUTE)
        + (Seconds * HUNDREDTHS_PER_SECOND);

    // necessary because in JavaScript, some values (such as 2.01) will have a lot of decimal
    // places when multiplied by a larger number. For instance, 2.01 turns into 2009.999999999999997.
    intTotalHundredths = Math.round(intTotalHundredths);

    return intTotalHundredths;
}

function ConvertHundredthsIntoSCORMTime (intTotalHundredths) {
    var intTotalMilliseconds,
        intHours,
        intMinutes,
        intSeconds,
        intHundredths,
        intMilliseconds,
        strCMITimeSpan;

    //
    // this function used to accept milliseconds, so just massage the argument here
    //
    intTotalMilliseconds = intTotalHundredths * 10;

    // extract time parts
    intMilliseconds = intTotalMilliseconds % 1000;
    intSeconds = ((intTotalMilliseconds - intMilliseconds) / 1000) % 60;
    intMinutes = ((intTotalMilliseconds - intMilliseconds - (intSeconds * 1000)) / 60000) % 60;
    intHours = (intTotalMilliseconds - intMilliseconds - (intSeconds * 1000) - (intMinutes * 60000)) / 3600000;

    //
    // deal with exceptional case when content used a huge amount of time and interpreted CMITimstamp
    // to allow a number of intMinutes and seconds greater than 60 i.e. 9999:99:99.99 instead of 9999:60:60:99
    // note: this case is permissable under SCORM, but will be exceptionally rare
    //
    // eslint-disable-next-line eqeqeq
    if (intHours == 10000) {
        intHours = 9999;

        intMinutes = (intTotalMilliseconds - (intHours * 3600000)) / 60000;
        // eslint-disable-next-line eqeqeq
        if (intMinutes == 100) {
            intMinutes = 99;
        }
        intMinutes = Math.floor(intMinutes);

        intSeconds = (intTotalMilliseconds - (intHours * 3600000) - (intMinutes * 60000)) / 1000;
        // eslint-disable-next-line eqeqeq
        if (intSeconds == 100) {
            intSeconds = 99;
        }
        intSeconds = Math.floor(intSeconds);

        intMilliseconds = intTotalMilliseconds - (intHours * 3600000) - (intMinutes * 60000) - (intSeconds * 1000);
    }

    // drop the extra precision from the milliseconds
    intHundredths = Math.floor(intMilliseconds / 10);

    // put in padding 0's and concatinate to get the proper format
    strCMITimeSpan = ZeroPad(intHours, 4) + ":" + ZeroPad(intMinutes, 2) + ":" + ZeroPad(intSeconds, 2) + "." + intHundredths;

    // check for case where total milliseconds is greater than max supported by strCMITimeSpan
    if (intHours > 9999) {
        strCMITimeSpan = "9999:99:99.99";
    }

    return strCMITimeSpan;
}

function ConvertCmiTimeSpanToHundredths (cmiTimeSpan) {
    var aryParts,
        intHours,
        intMinutes,
        intSeconds,
        intTotalHundredths;

    if (cmiTimeSpan === "") {
        return 0;
    }

    // split the string into its parts
    aryParts = cmiTimeSpan.split(":");

    // seperate the parts and multiply by the appropriate constant (360000 = num hundredths in an hour, etc)
    intHours = aryParts[0];
    intMinutes = aryParts[1];

    // don't need to worry about hundredths b/c they are expressed as fractions of a second
    intSeconds = aryParts[2];

    intTotalHundredths = (intHours * 360000) + (intMinutes * 6000) + (intSeconds * 100);

    // necessary because in JavaScript, some values for intSeconds (such as 2.01) will have a lot of decimal
    // places when multiplied by 1000. For instance, 2.01 turns into 2009.999999999999997.
    intTotalHundredths = Math.round(intTotalHundredths);

    return intTotalHundredths;
}

function ConvertHundredthsToIso8601TimeSpan (totalHundredths) {
    var iso8601Time = "",

        // decrementing counter - work at the hundreths of a second level because that is all the precision that is required
        HundredthsOfASecond = totalHundredths,
        // 100 hundreths of a seconds
        Seconds,
        // 60 seconds
        Minutes,
        // 60 minutes
        Hours,
        // 24 hours
        Days,
        // assumed to be an "average" month (figures a leap year every 4 years) = ((365*4) + 1) / 48 days - 30.4375 days per month
        Months,
        // assumed to be 12 "average" months
        Years;

    Years = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_YEAR);
    HundredthsOfASecond -= Years * HUNDREDTHS_PER_YEAR;

    Months = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MONTH);
    HundredthsOfASecond -= Months * HUNDREDTHS_PER_MONTH;

    Days = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_DAY);
    HundredthsOfASecond -= Days * HUNDREDTHS_PER_DAY;

    Hours = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_HOUR);
    HundredthsOfASecond -= Hours * HUNDREDTHS_PER_HOUR;

    Minutes = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MINUTE);
    HundredthsOfASecond -= Minutes * HUNDREDTHS_PER_MINUTE;

    Seconds = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_SECOND);
    HundredthsOfASecond -= Seconds * HUNDREDTHS_PER_SECOND;

    if (Years > 0) {
        iso8601Time += Years + "Y";
    }
    if (Months > 0) {
        iso8601Time += Months + "M";
    }
    if (Days > 0) {
        iso8601Time += Days + "D";
    }

    // check to see if we have any time before adding the "T"
    if ((HundredthsOfASecond + Seconds + Minutes + Hours) > 0) {
        iso8601Time += "T";

        if (Hours > 0) {
            iso8601Time += Hours + "H";
        }
        if (Minutes > 0) {
            iso8601Time += Minutes + "M";
        }
        if ((HundredthsOfASecond + Seconds) > 0) {
            iso8601Time += Seconds;

            if (HundredthsOfASecond > 0) {
                iso8601Time += "." + HundredthsOfASecond;
            }

            iso8601Time += "S";
        }
    }

    if (iso8601Time === "") {
        iso8601Time = "T0H0M0S";
    }

    iso8601Time = "P" + iso8601Time;

    return iso8601Time;
}

// eslint-disable-next-line no-unused-vars
function ConvertIso8601TimeSpanToCmiTimeSpan (iso8601TimeSpan) {
    var hundredths = ConvertIso8601TimeSpanToHundredths(iso8601TimeSpan),
        cmiRepresentation = ConvertHundredthsIntoSCORMTime(hundredths);

    return cmiRepresentation;
}

// eslint-disable-next-line no-unused-vars
function ConvertCmiTimeSpanToIso8601TimeSpan (cmiTimeSpan) {
    var hundredths = ConvertCmiTimeSpanToHundredths(cmiTimeSpan),
        isoRepresentation = ConvertHundredthsToIso8601TimeSpan(hundredths);

    return isoRepresentation;
}

// eslint-disable-next-line no-unused-vars
function ConvertCmiTimeToIso8601Time (cmiTime) {
    //
    // assumes that cmiTime is a valid CmiTime (hh:mm:ss.s)
    // since CmiTime doesn't have any concept of a date, we'll assume that the
    // current date is the best selection this assumption should be ok since in
    // SCORM 1.2, the only time CmiTime is used is for interactions which are
    // only written once
    //
    var dtmNow = new Date(),
        year = dtmNow.getFullYear(),
        month = dtmNow.getMonth(),
        day = dtmNow.getDate();

    year = ZeroPad(year, 4);
    month = ZeroPad(month + 1, 2);
    day = ZeroPad(day, 2);

    return year + "-" + month + "-" + day + "T" + cmiTime;
}

// eslint-disable-next-line no-unused-vars
function RemoveIndiciesFromCmiElement (element) {
    return element.replace(REG_EX_DIGITS, "n");
}

// eslint-disable-next-line no-unused-vars
function ExtractIndex (strElementName) {
    var strIndex = "",
        aryMatches;

    // get the first ".#." from the string
    aryMatches = strElementName.match(/\.\d+\./);

    if (aryMatches !== null && aryMatches.length > 0) {
        // drop the periods
        strIndex = aryMatches[0].replace(/\./g, "");
        strIndex = parseInt(strIndex, 10);
    }

    return strIndex;
}

// eslint-disable-next-line no-unused-vars
function ExtractSecondaryIndex (strElementName) {
    var strIndex = "",
        aryMatches;

    // get the first ".#." from the string

    aryMatches = strElementName.match(/\.\d+\./g);

    if (aryMatches !== null && aryMatches.length > 1) {
        // drop the periods
        strIndex = aryMatches[1].replace(/\./g, "");
        strIndex = parseInt(strIndex, 10);
    }

    return strIndex;
}

// eslint-disable-next-line no-unused-vars
function TranslateDualStausToSingleStatus (completionStatus, successStatus) {
    var returnValue = null;

    switch (successStatus) {
        case SCORM_STATUS_PASSED:
            returnValue = SCORM_STATUS_PASSED;
            break;

        case SCORM_STATUS_FAILED:
            returnValue = SCORM_STATUS_FAILED;
            break;

        case SCORM_STATUS_UNKNOWN:
            if (completionStatus === SCORM_STATUS_COMPLETED) {
                returnValue = SCORM_STATUS_COMPLETED;
            }
            else if (completionStatus === SCORM_STATUS_INCOMPLETE) {
                returnValue = SCORM_STATUS_INCOMPLETE;
            }
            else if (completionStatus === SCORM_STATUS_UNKNOWN || completionStatus === SCORM_STATUS_NOT_ATTEMPTED) {
                returnValue = SCORM_STATUS_NOT_ATTEMPTED;
            }
            else if (completionStatus === SCORM_STATUS_BROWSED) {
                returnValue = SCORM_STATUS_BROWSED;
            }
            break;

        default:
            break;
    }

    if (returnValue === null) {
        Debug.AssertError("Invalid status combination encountered in GetValue - Success = " + successStatus + ", Completion = " + completionStatus);

        return "";
    }

    return returnValue;
}

// eslint-disable-next-line no-unused-vars
function TranslateSingleStatusIntoSuccess (singleStatus) {
    var returnValue;

    switch (singleStatus) {
        case SCORM_STATUS_PASSED:
            returnValue = SCORM_STATUS_PASSED;
            break;

        case SCORM_STATUS_COMPLETED:
            returnValue = SCORM_STATUS_UNKNOWN;
            break;

        case SCORM_STATUS_FAILED:
            returnValue = SCORM_STATUS_FAILED;
            break;

        case SCORM_STATUS_INCOMPLETE:
            returnValue = SCORM_STATUS_UNKNOWN;
            break;

        case SCORM_STATUS_BROWSED:
            returnValue = SCORM_STATUS_UNKNOWN;
            break;

        case SCORM_STATUS_NOT_ATTEMPTED:
            returnValue = SCORM_STATUS_UNKNOWN;
            break;

        default:
            Debug.AssertError("Unrecognized single status");
    }

    return returnValue;
}

// eslint-disable-next-line no-unused-vars
function TranslateSingleStatusIntoCompletion (singleStatus) {
    var returnValue;

    switch (singleStatus) {
        case SCORM_STATUS_PASSED:
            returnValue = SCORM_STATUS_COMPLETED;
            break;

        case SCORM_STATUS_COMPLETED:
            returnValue = SCORM_STATUS_COMPLETED;
            break;

        case SCORM_STATUS_FAILED:
            if (Control.Package.Properties.CompletionStatOfFailedSuccessStat === SCORM_STATUS_COMPLETED || Control.Package.Properties.CompletionStatOfFailedSuccessStat === SCORM_STATUS_INCOMPLETE) {
                returnValue = Control.Package.Properties.CompletionStatOfFailedSuccessStat;
            }
            else {
                returnValue = SCORM_STATUS_COMPLETED;
            }
            break;

        case SCORM_STATUS_INCOMPLETE:
            returnValue = SCORM_STATUS_INCOMPLETE;
            break;

        case SCORM_STATUS_BROWSED:
            returnValue = SCORM_STATUS_BROWSED;
            break;

        case SCORM_STATUS_NOT_ATTEMPTED:
            returnValue = SCORM_STATUS_NOT_ATTEMPTED;
            break;

        default:
            Debug.AssertError("Unrecognized single status");
    }

    return returnValue;
}

// eslint-disable-next-line no-unused-vars
function IsValidCMITimeSpan (value) {
    var regValid = /^\d?\d?\d\d:\d\d:\d\d(.\d\d?)?$/;

    if (value.search(regValid) > -1) {
        return true;
    }

    return false;
}

function IsValidCMIDecimal (value) {
    // check for characters "0-9", ".", and "-" only
    if (value.search(/[^.\d-]/) > -1) {
        return false;
    }

    // if contains a dash, ensure it is first and that there is only 1
    if (value.search("-") > -1 && value.indexOf("-", 1) > -1) {
        return false;
    }

    // ensure only 1 decimal point
    if (value.indexOf(".") !== value.lastIndexOf(".")) {
        return false;
    }

    // ensure there is at least 1 digit
    if (value.search(/\d/) < 0) {
        return false;
    }

    return true;
}

// eslint-disable-next-line no-unused-vars
function IsValidCMIIdentifier (value) {
    // validate string length
    if (value.length > 255) {
        return false;
    }

    // can't pass the test suite unless you prohibit empty strings from being set as well
    if (value === "") {
        return false;
    }

    return true;
}

// eslint-disable-next-line no-unused-vars
function IsValidCMISInteger (value) {
    // check for characters "0-9", and "-" only
    if (value.search(/[^\d-]/) > -1) {
        return false;
    }

    // if contains a dash, ensure it is first and that there is only 1
    if (value.search("-") > -1 && value.indexOf("-", 1) > -1) {
        return false;
    }

    // ensure there is at least 1 digit
    if (value.search(/\d/) < 0) {
        return false;
    }

    value = parseInt(value, 10);
    if (value < -32768 || value > 32768) {
        return false;
    }

    return true;
}

// eslint-disable-next-line no-unused-vars
function IsValidCMITime (value) {
    var regValid = /^\d\d:\d\d:\d\d(.\d\d?)?$/,
        aryParts,
        intHours,
        intMinutes,
        arySeconds,
        intSeconds,
        intSecondFraction = 0;

    // check for proper format
    if (value.search(regValid) < 0) {
        return false;
    }

    // break the string into its parts and validate each part
    aryParts = value.split(":");

    intHours = aryParts[0];
    intMinutes = aryParts[1];

    arySeconds = aryParts[2].split(".");
    intSeconds = arySeconds[0];

    if (arySeconds.length > 1) {
        intSecondFraction = arySeconds[1];
    }

    if (intHours < 0 || intHours > 23) {
        return false;
    }

    if (intMinutes < 0 || intMinutes > 59) {
        return false;
    }

    if (intSeconds < 0 || intSeconds > 59) {
        return false;
    }

    if (intSecondFraction < 0 || intSecondFraction > 99) {
        return false;
    }

    return true;
}

// eslint-disable-next-line no-unused-vars
function IsValidCMIFeedback (interactionType, value) {
    // be sure to check length on server

    // no response can be greater than 4096 characters
    if (value.length > 4096) {
        return false;
    }

    if (rscpCfg.get("registrationToDeliver").Package.Properties.ValidateInteractionResponses) {
        // even though things are technically supposed to be lower case, allow upper case letters to come in
        value = value.toLowerCase();

        switch (interactionType) {
            case "true-false":
                // must start with one of these characters - 0,1,t,f
                if (value.search(/^[01tf]/) !== 0) {
                    return false;
                }
                break;

            case "choice":
                // comma delimited list of single digit lower case letters or numbers surrounded by optional {}
                if (value.search(/(^(([a-z0-9])|(([a-z0-9],)+[a-z0-9]))$)|(^\{(([a-z0-9])|(([a-z0-9],)+[a-z0-9]))\}$)/) !== 0) {
                    return false;
                }
                break;

            case "fill-in":
                // any alphanumeric string up to 255 chars
                if (value.length > 255) {
                    return false;
                }
                break;

            case "numeric":
                if (! IsValidCMIDecimal(value)) {
                    return false;
                }
                break;

            case "likert":
                // there are no restrictions on the likert format in SCORM 1.2
                break;

            case "matching":
                if (value.search(/(^[0-9a-z]\.[0-9a-z]$)|(^([0-9a-z]\.[0-9a-z],)+([0-9a-z]\.[0-9a-z])$)|(^\{[0-9a-z]\.[0-9a-z]\}$)|(^\{([0-9a-z]\.[0-9a-z],)+([0-9a-z]\.[0-9a-z])\}$)/) !== 0) {
                    return false;
                }
                break;

            case "performance":
                if (value.length > 255) {
                    return false;
                }
                break;

            case "sequencing":
                // comma delimited list of single digit lower case letters or numbers
                if (value.search(/(^[a-z0-9]$)|(^([a-z0-9],)+[a-z0-9]$)/) !== 0) {
                    return false;
                }
                break;

            default:
                // we are unable to determine the type (possibly b/c it hasn't yet been set) so just accept anything
                // we will re-check this value when the type is set
                break;
        }
    }

    return true;
}

// normalizes a raw score to a scaled score between 0-1
// eslint-disable-next-line no-unused-vars
function NormalizeRawScore (rawScore, minScore, maxScore) {
    // raw score is required to be a valid decimal 0-100 in SCORM 1.2
    var normalizedScore = null;

    if (typeof minScore !== "undefined" && minScore !== null) {
        minScore = parseFloat(minScore);
    }

    if (typeof maxScore !== "undefined" && maxScore !== null) {
        maxScore = parseFloat(maxScore);
    }

    if (typeof rawScore !== "undefined" && rawScore !== null) {
        rawScore = parseFloat(rawScore);

        if (typeof minScore !== "undefined"
            && minScore !== null
            && typeof maxScore !== "undefined"
            && maxScore !== null
            && rawScore >= minScore
            && rawScore <= maxScore
        ) {
            if (minScore === maxScore) {
                // Account for the strange case where min/max/raw are all set to zero. We should return 0
                // when the raw score is zero regardless of the min/max.
                if (rawScore === 0) {
                    normalizedScore = 0;
                }
                else {
                    normalizedScore = 1;
                }
            }
            else {
                normalizedScore = (rawScore - minScore) / (maxScore - minScore);
            }
        }
        // no valid min and max score, so try to assume that the score is 0-100
        else if (rawScore >= 0 && rawScore <= 100) {
            normalizedScore = rawScore / 100;
        }
    }

    if (normalizedScore !== null) {
        return RoundToPrecision(normalizedScore, 7);
    }

    return null;
}
